<template>
  <modal
    :state="state"
    :index="index"
    @toggle-modal="cancel"
    :should-cancel-on-outside-click="false"
  >
    <div slot="body" class="email-modal">
      <h3 class="modal-title">
        <template v-if="bulk">Bulk</template>
        Send a Custom Notification
      </h3>

      <div class="form-style">
        <row v-if="!bulk">
          <column class="row-title" size="100">
            <label for="to-field" class="v-label">To:</label>
          </column>
          <column>
            <input
              v-if="entry.owner"
              type="text"
              id="to-field"
              v-model="entry.owner.email"
              disabled
            />
          </column>
        </row>

        <row>
          <column class="row-title" size="100">
            <label for="subject-field" class="v-label">Subject:</label>
          </column>
          <column>
            <input
              type="text"
              v-model="subject"
              placeholder="Enter a subject line"
              id="subject-field"
            />
          </column>
        </row>

        <label class="label" for="body-field">Notification Body:</label>
        <wysiwyg
          id="body-field"
          name="body-field"
          :set-tag="false"
          v-model="body"
          placeholder="Type your message here"
          :config-options="wysiwygConfigOptions"
        ></wysiwyg>
      </div>

      <hr />

      <div class="cta">
        <button @click="cancel" class="btn block red outline">Cancel</button>
        <button @click="send" class="btn block green">
          {{ bulk ? 'Continue' : 'Send' }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
import Vue from "vue";
import ObjectModelEntry from "~/models/objectModelEntries/objectModelEntry";
import Wysiwyg from "~/components/wysiwyg/wysiwyg.vue";

export default Vue.extend({
  props: {
    state: Object,
    entry: Object as () => ObjectModelEntry,
    bulk: {type: Boolean, default: false}
  },
  components: {
    Wysiwyg
  },
  data: function() {
    return {
      subject: "",
      body: "",
      wysiwygConfigOptions: {
        toolbarButtons: [
          "bold",
          "italic",
          "underline",
          "|",
          "formatOL",
          "formatUL",
          "|",
          "indent",
          "outdent",
          "insertLink"
        ],
        toolbarInline: false,
        toolbarBottom: true,
        toolbarContainer: null,
        toolbarVisibleWithoutSelection: true,
        zIndex: 20,
        tabSpaces: false
      }
    };
  },
  methods: {
    cancel() {
      this.emitHideModal();
    },
    send() {
      this.$emit("send", {
        subject: this.subject,
        body: this.body
      });
    }
  }
});
</script>